import React from 'react';
import BEMHelper from 'react-bem-helper';
import { IMAGES_REPO } from '../../config';
import Modal from '../../components/Render/Modal/Modal';
import ImageUploader from '../../components/ImageUploader';

const bem = new BEMHelper({
  name: 'gallery',
  prefix: 'planet-'
});

export default class GalleryInput extends React.Component {

  state = {
    isOpen: false
  };

  removeImage = (index) => {
    this.props.fields.remove(index);
  };

  addImages = (imagesUrl) => {
    const fields = this.props.fields;
    imagesUrl.map((imageUrl) => {
      return fields.push(imageUrl);
    });
  };

  toggleModal = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { fields } = this.props;
    return (
      <div {...bem()}>
        <label>Gallery</label>
        <div {...bem('container')}>
          <div className="row">
            {
              fields.map((obj, index) => {
                const imgUrl = fields.get(index);
                return (
                  <div className="col-xs-3">
                    <div {...bem('image-container')}>
                      <button
                        type="button"
                        onClick={() => {
                          this.removeImage(index);
                        }}
                        className="btn btn-sm btn-primary btn-remove btn-circle">
                      <span
                        className="fa fa-remove"></span>
                      </button>
                      <img className="responsive-image" src={IMAGES_REPO + '' + imgUrl}/>
                    </div>
                  </div>
                );
              })
            }
            <div className="col-xs-3">
              <div {...bem('image-container', 'empty')}>
                <span onClick={this.toggleModal} className="add-more fa fa-plus"></span>
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.isOpen}>
          <ImageUploader
            isMultipleSelect={true}
            select={this.addImages}
            cancel={this.toggleModal}/>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/gallery-input/index.js